module.exports = Promise.all([__parcel__import__("ghDyT"), __parcel__import__("brqnp")]).then(() => parcelRequire('4qady'));